(function () {
  'use strict';

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLocaleLowerCase('de-CH')
      .replace(/ß/g, 'ss')
      .replace(/ä|ae/g, 'a')
      .replace(/ö|oe/g, 'o')
      .replace(/ü|ue/g, 'u')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function splitAliases(value) {
    return String(value || '')
      .split('|')
      .map(normalizeSearchValue)
      .filter(Boolean);
  }

  function getSearchRank(query, term, aliases, definition, cluster) {
    if (!query) return 10;

    var normalizedTerm = normalizeSearchValue(term);
    var normalizedAliases = splitAliases(aliases);
    var normalizedDefinition = normalizeSearchValue(definition);
    var normalizedCluster = normalizeSearchValue(cluster);

    if (normalizedTerm === query) return 0;
    if (normalizedAliases.indexOf(query) !== -1) return 1;
    if (normalizedTerm.indexOf(query) === 0) return 2;
    if (normalizedAliases.some(function (alias) { return alias.indexOf(query) === 0; })) return 3;

    var haystack = [normalizedTerm]
      .concat(normalizedAliases)
      .concat([normalizedDefinition, normalizedCluster])
      .join(' ');

    return haystack.indexOf(query) !== -1 ? 4 : -1;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      normalizeSearchValue: normalizeSearchValue,
      getSearchRank: getSearchRank
    };
  }

  if (typeof window === 'undefined' || typeof document === 'undefined' || typeof HTMLElement === 'undefined') {
    return;
  }

  document.documentElement.classList.add('fb-wissen-js');

  class FuelboxWissenIndex extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.controls = this.querySelector('[data-wissen-controls]');
      this.searchInput = this.querySelector('[data-wissen-search]');
      this.clearButton = this.querySelector('[data-wissen-clear]');
      this.resetButton = this.querySelector('[data-wissen-reset]');
      this.status = this.querySelector('[data-wissen-status]');
      this.emptyState = this.querySelector('[data-wissen-empty]');
      this.grid = this.querySelector('[data-wissen-grid]');
      this.cards = Array.from(this.querySelectorAll('[data-wissen-card]'));
      this.filters = Array.from(this.querySelectorAll('[data-wissen-filter]'));
      this.activeCluster = 'all';
      this.originalOrder = this.cards.slice();

      if (!this.controls || !this.searchInput || !this.grid || !this.cards.length) return;

      this.dataset.initialized = 'true';
      this.controls.hidden = false;
      this.bindEvents();
      this.applyFilters();
    }

    bindEvents() {
      this.searchInput.addEventListener('input', () => this.applyFilters());

      if (this.clearButton) {
        this.clearButton.addEventListener('click', () => {
          this.searchInput.value = '';
          this.applyFilters();
          this.searchInput.focus();
        });
      }

      if (this.resetButton) {
        this.resetButton.addEventListener('click', () => this.resetFilters());
      }

      this.filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          this.activeCluster = filter.dataset.cluster || 'all';
          this.filters.forEach((candidate) => {
            candidate.setAttribute('aria-pressed', String(candidate === filter));
          });
          this.applyFilters();
        });
      });
    }

    resetFilters() {
      this.searchInput.value = '';
      this.activeCluster = 'all';
      this.filters.forEach((filter) => {
        filter.setAttribute('aria-pressed', String(filter.dataset.cluster === 'all'));
      });
      this.applyFilters();
      this.searchInput.focus();
    }

    applyFilters() {
      var query = normalizeSearchValue(this.searchInput.value);
      var rankedCards = [];

      this.cards.forEach((card, originalIndex) => {
        var clusterMatches = this.activeCluster === 'all' || card.dataset.cluster === this.activeCluster;
        var rank = getSearchRank(
          query,
          card.dataset.term,
          card.dataset.aliases,
          card.dataset.definition,
          card.dataset.clusterLabel
        );
        var searchMatches = !query || rank >= 0;
        var visible = clusterMatches && searchMatches;

        card.hidden = !visible;
        if (visible) rankedCards.push({ card: card, rank: rank, originalIndex: originalIndex });
      });

      rankedCards.sort((a, b) => {
        if (!query || a.rank === b.rank) return a.originalIndex - b.originalIndex;
        return a.rank - b.rank;
      });

      rankedCards.forEach((item) => this.grid.appendChild(item.card));

      if (!query) {
        this.originalOrder.forEach((card) => this.grid.appendChild(card));
      }

      var resultCount = rankedCards.length;
      var hasActiveState = Boolean(query) || this.activeCluster !== 'all';

      if (this.status) {
        this.status.textContent = resultCount === 1 ? '1 Begriff' : resultCount + ' Begriffe';
      }
      if (this.emptyState) this.emptyState.hidden = resultCount !== 0;
      if (this.clearButton) this.clearButton.hidden = !this.searchInput.value;
      if (this.resetButton) this.resetButton.hidden = !hasActiveState;
    }
  }

  if (!customElements.get('fuelbox-wissen-index')) {
    customElements.define('fuelbox-wissen-index', FuelboxWissenIndex);
  }
})();
